export function loadInformerAsModule(context) {
    return import("./renderer").then((module) => module.renderAsModule(context));
}

export default function loadInformer(context, config) {
    import("./renderer").then((module) => module.default(context, config));
    return context;
}
